module.exports = "/images/backgroundWhiteLoginDeliveryman.svg";